import React, { useEffect, useState } from "react";
import "./Cart.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import GrayBoxWithText from "./GrayBoxWithText/GrayBoxWithText";
import SelectAddressComponent from "./SelectAddressComponent/SelectAddressComponent";
import YellowStripTitleComponent from "../Common-Component/YellowStripTitleComponent/YellowStripTitleComponent";
import OrderSummaryComponent from "./OrderSummaryComponent/OrderSummaryComponent";
import PlaceOrderComponent from "./PlaceOrderComponent/PlaceOrderComponent";
import OrderSummary from "../Common-Component/OrderSummary/OrderSummary";
import UpdateProfileModal from "../Common-Component/Common_Modal/UpdateProfileModal/UpdateProfileModal";
import PincodeModal from "../Common-Component/Common_Modal/PincodeModal/PincodeModal";
import AddedToCartModal from "../Common-Component/Common_Modal/AddedToCartModal/AddedToCartModal";
import OrderSuccesFullModal from "../Common-Component/Common_Modal/OrderSuccesFullModal/OrderSuccesFullModal";
import ViewMeassageOffCanvas from "../Common-Component/Common_Modal/ViewMeassageOffCanvas/ViewMeassageOffCanvas";
import UploadFileModal from "../Common-Component/Common_Modal/UploadFileModal/UploadFileModal";
import RatingSubmittedModal from "../Common-Component/Common_Modal/RatingSubmittedModal/RatingSubmittedModal";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
const Cart = () => {
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "Cart" }, //
  ];
  const cart = useSelector((state) => state.cart.allCarts);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCart());
  }, [dispatch]);
  const [showSelectAddress, setShowSelectAddress] = useState(false);
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [shwoPlaceOrder, setShwoPlaceOrder] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [paymenyMethodId, setPaymenyMethodId] = useState(2);
  const [showPincodeModal, setShowPincodeModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);

  const handleShowPincodeModal = () => setShowPincodeModal(true);
  const handleHidePincodeModal = () => setShowPincodeModal(false);

  const [showOffcanvas, setshowOffcanvas] = useState(false);

  const location = useLocation();
  const { data, CouponData, orderData } = location.state || {};

  const [billingAddressId, setBillingAddressId] = useState(null);
  const [shippingAddressId, setShippingAddressId] = useState(null);
  const [pincodeData, setPincodeData] = useState("");

  return (
    <section className="Cart">
      <div className="custom_container">
        <div className="breadcrump_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={breadcrumbData} />
          </div>
        </div>

        <div className="cart_section_main_holder">
          <div className="row custom_row">
            <div className="col-xl-9 col-lg-9 ">
              <GrayBoxWithText onClick={handleShowPincodeModal} />

              <div className="address_div">
                {!showSelectAddress && (
                  <div
                    onClick={() => {
                      setShowSelectAddress(true);
                    }}
                  >
                    <YellowStripTitleComponent heading="Select Address" />
                  </div>
                )}

                {showSelectAddress && (
                  <SelectAddressComponent
                    setShowOrderSummary={setShowOrderSummary}
                    billingAddressId={billingAddressId}
                    setBillingAddressId={setBillingAddressId}
                    shippingAddressId={shippingAddressId}
                    setShippingAddressId={setShippingAddressId}
                  />
                )}
              </div>

              <div className="order_summary_div">
                {!showOrderSummary && (
                  <div
                  // onClick={() => {
                  //   setShowOrderSummary(true);
                  // }}
                  >
                    <YellowStripTitleComponent heading="Order Summary" />
                  </div>
                )}

                {showOrderSummary && (
                  <OrderSummaryComponent
                    cart={cart}
                    setShwoPlaceOrder={setShwoPlaceOrder}
                  />
                )}
              </div>

              <div className="place_order_div">
                {!shwoPlaceOrder && (
                  <div
                  // onClick={() => {
                  //   setShwoPlaceOrder(true);
                  // }}
                  >
                    <YellowStripTitleComponent heading="Payment" />
                  </div>
                )}

                {shwoPlaceOrder && (
                  <PlaceOrderComponent
                    shippingAddressId={shippingAddressId}
                    billingAddressId={billingAddressId}
                    data={data}
                    CouponData={CouponData}
                    orderData={orderData}
                    paymenyMethodId={paymenyMethodId}
                    setPaymenyMethodId={setPaymenyMethodId}
                    pincodeData={pincodeData}
                    cart={cart}
                  />
                )}
              </div>
            </div>
            <div className="col-xl-3 col-lg-5 col-md-6">
              <OrderSummary cart={cart} />
            </div>
          </div>
        </div>
      </div>

      <PincodeModal
        setPincodeData={setPincodeData}
        pincodeData={pincodeData}
        show={showPincodeModal}
        onHide={handleHidePincodeModal}
      />

      <AddedToCartModal
        show={showCartModal}
        onHide={() => {
          setShowCartModal(false);
        }}
      />

      {/* <UploadFileModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      /> */}

      <RatingSubmittedModal
        successText="Rating Submitted Successfully!"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      {/* <UpdateProfileModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      /> */}

      <ViewMeassageOffCanvas
        onHide={() => setshowOffcanvas(false)}
        show={showOffcanvas}
      />
    </section>
  );
};

export default Cart;
